module.exports = __webpack_public_path__ + "static/media/logo-nav.7b2438d5.png";